module.exports = __webpack_public_path__ + "static/onTheIssues_Economy_2-79a549c2fc625fd2ef01269702e9ba03.jpg";